import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const ProductsIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M31.055 15.328l-14.4-14.4c-0.576-0.576-1.376-0.928-2.256-0.928h-11.2c-1.76 0-3.2 1.44-3.2 3.2v11.2c0 0.88 0.352 1.68 0.944 2.272l14.4 14.4c0.576 0.576 1.376 0.928 2.256 0.928s1.68-0.352 2.256-0.944l11.2-11.2c0.592-0.576 0.944-1.376 0.944-2.256s-0.368-1.696-0.944-2.272zM5.6 8c-1.328 0-2.4-1.072-2.4-2.4s1.072-2.4 2.4-2.4c1.328 0 2.4 1.072 2.4 2.4s-1.072 2.4-2.4 2.4z"
  }));
};
export default /*#__PURE__*/memo(ProductsIcon);